import { MapContainer, Marker, TileLayer } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const icon = L.divIcon({ className: "", html: '<div style="width:18px;height:18px;border-radius:50%;background:#F04E23;border:3px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,.5)"></div>', iconSize: [18, 18], iconAnchor: [9, 9] });

export function MiniMap({ lat, lng, className = "h-36", testid }) {
  if (lat == null || lng == null) return null;
  const pos = [Number(lat), Number(lng)];
  return (
    <div className={`relative rounded-xl overflow-hidden border border-border ${className}`} data-testid={testid}>
      <MapContainer center={pos} zoom={16} className="h-full w-full" zoomControl={false} dragging={false} scrollWheelZoom={false} doubleClickZoom={false} touchZoom={false} attributionControl={false}>
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <Marker position={pos} icon={icon} />
      </MapContainer>
      <a href={`https://www.google.com/maps?q=${pos[0]},${pos[1]}`} target="_blank" rel="noreferrer" className="absolute bottom-1.5 right-1.5 z-[1000] rounded-md bg-white/90 dark:bg-black/70 px-2 py-0.5 text-[10px] font-mono text-sky-600 dark:text-sky-300 shadow hover:underline">{pos[0].toFixed(5)}, {pos[1].toFixed(5)} ↗</a>
    </div>
  );
}
